import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAdminBuildings_idCollection_points = z.any()
export type TagsPostAdminBuildings_idCollection_points = z.infer<typeof tagsPostAdminBuildings_idCollection_points>

export const paramsPostAdminBuildings_idCollection_points = z.object({ "id": z.string() })
export type ParamsPostAdminBuildings_idCollection_points = z.infer<typeof paramsPostAdminBuildings_idCollection_points>

export const bodyPostAdminBuildings_idCollection_points = z.object({ "name": z.string(), "identifier": z.string(), "type": z.union([z.literal("electricity"), z.literal("gas"), z.literal("water"), z.literal("coal"), z.literal("heat"), z.literal("other")]), "supplier": z.string().optional(), "price": z.string().optional(), "singleRateTariff": z.boolean().optional() })
export type BodyPostAdminBuildings_idCollection_points = z.infer<typeof bodyPostAdminBuildings_idCollection_points>

export const responsePostAdminBuildings_idCollection_points = z.object({ "payload": z.object({ "id": z.string().max(191), "buildingId": z.string().max(255), "name": z.string().max(255), "type": z.union([z.literal("electricity"), z.literal("gas"), z.literal("water"), z.literal("coal"), z.literal("heat"), z.literal("other")]), "identifier": z.string().max(255), "customType": z.union([z.string().max(100), z.null()]), "supplier": z.union([z.string().max(255), z.null()]), "price": z.union([z.string(), z.null()]), "distributionRate": z.union([z.string().max(50), z.null()]), "breaker": z.union([z.string().max(10), z.null()]), "singleRateTariff": z.boolean(), "meterCodes": z.union([z.union([z.union([z.string(), z.number(), z.boolean(), z.null()]), z.array(z.any()), z.record(z.any()).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.any().safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
})]), z.null()]), "gasCalorificValue": z.union([z.string(), z.null()]), "gasVolumeCoefficient": z.union([z.string(), z.null()]), "consumptionReminderEnabled": z.boolean(), "consumptionReminderStartDate": z.union([z.string(), z.null()]), "consumptionReminderFrequency": z.union([z.literal("weekly"), z.literal("monthly"), z.literal("yearly")]), "order": z.string(), "createdAt": z.string(), "updatedAt": z.string(), "deletedAt": z.union([z.string(), z.null()]) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostAdminBuildings_idCollection_points = z.infer<typeof responsePostAdminBuildings_idCollection_points>

interface IPostAdminBuildings_idCollection_points extends BaseMethodType {
  tags: TagsPostAdminBuildings_idCollection_points,
  params: ParamsPostAdminBuildings_idCollection_points,
  body: BodyPostAdminBuildings_idCollection_points,
  response: ResponsePostAdminBuildings_idCollection_points
}
export const URL = '/admin/buildings/:id/collection-points'
export const validation = {
  post: {
    tags: tagsPostAdminBuildings_idCollection_points,
    params: paramsPostAdminBuildings_idCollection_points,
    body: bodyPostAdminBuildings_idCollection_points,
    response: responsePostAdminBuildings_idCollection_points
  }
}
export interface AdminBuildings_idCollection_points extends BaseRouteType {
  post: IPostAdminBuildings_idCollection_points
}